import { calculateHashes } from './fileUtils';

export function assertSafeRelativePath(name: string): void {
  if (
    !name ||
    /\\/.test(name) ||
    /^[a-zA-Z]:\//.test(name) ||
    [...name].some(
      (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127
    ) ||
    name.split('/').some((part) => !part || part === '.' || part === '..')
  ) {
    throw new Error('Unsafe relative file path');
  }
}

export async function verifyDownloadedFile(
  blob: Blob,
  file: { fileName: string; size: number; fullHash: string }
): Promise<void> {
  assertSafeRelativePath(file.fileName);
  if (
    !Number.isSafeInteger(file.size) ||
    file.size < 0 ||
    !/^[a-f0-9]{64}$/.test(file.fullHash)
  ) {
    throw new Error(`Missing valid integrity metadata for ${file.fileName}`);
  }
  if (
    blob.size !== file.size ||
    (await calculateHashes(blob)).fullHash !== file.fullHash
  ) {
    throw new Error(
      `Downloaded file failed integrity verification: ${file.fileName}. Local file was not replaced.`
    );
  }
}
